<div class="grid p-fluid flex-row-reverse dashboard-graph-grid">
  <div class="col-12">
    <!--
    <ng-template #header>
      <div class="m-4 mb-0 p-card-title flex flex-row justify-content-between">
        <strong>Modifica Utente</strong>
        <button pButton type="button" label="Salva" (click)="saveUser()"></button>
      </div>
    </ng-template>
    -->
    <div class="grid">
      <div class="col-6">
        <app-input label="Username" type="text" [(model)]="user.username" [showLength]="false"></app-input>
      </div>
      <div class="col-6">
        <app-input label="Email" type="text" [(model)]="user.mail" [showLength]="false"></app-input>
      </div>
    </div>
    <div class="grid">
      <div class="col-6">
        <app-input label="Nome" type="text" [(model)]="user.name" [showLength]="false"></app-input>
      </div>
      <div class="col-6">
        <app-input label="Cognome" type="text" [(model)]="user.surname" [showLength]="false"></app-input>
      </div>
    </div>

    <div class="grid">
      <div class="col-6">
        <app-input label="Password" type="text" [(model)]="user.password" [showLength]="false"></app-input>
        <i>Inserisci una nuova password solo se desideri cambiare la password attuale dell'utente.</i>
      </div>
      <div class="col-6">
        <app-checkbox label="Attivo" [(model)]="user.active" labelWidth="200px"></app-checkbox>
      </div>
    </div>
    <hr>
    <div class="flex flex-row justify-content-between">
      <app-action-button severity="success" type="save" (click)="saveUser()" label="Salva"></app-action-button>
      <app-action-button [textButton]="true" type="cancel" (click)="close()" label="Annulla"></app-action-button>
    </div>
  </div>
</div>
